var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED1F34"
    },
    d: "M7.287,256v139.901c0,60.095,48.717,108.812,108.812,108.812h279.803 c60.092,0,108.807-48.712,108.812-108.803V256H7.287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M504.714,116.089C504.708,55.998,455.994,7.286,395.901,7.286H116.099 C56.003,7.286,7.287,56.003,7.287,116.099V256h497.427V116.089z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M395.901,0H116.099C52.082,0,0,52.082,0,116.099v279.803C0,459.918,52.082,512,116.099,512h279.803 C459.918,512,512,459.918,512,395.901V116.099C512,52.082,459.918,0,395.901,0z M395.901,497.427H116.099 c-55.982,0-101.526-45.544-101.526-101.526V263.286H73.61c4.024,0,7.286-3.262,7.286-7.286s-3.262-7.286-7.286-7.286H14.573V116.099 c0-55.982,45.544-101.526,101.526-101.526h279.803c55.981,0,101.526,45.544,101.526,101.526v132.615H106.772 c-4.024,0-7.286,3.262-7.286,7.286c0,4.024,3.262,7.286,7.286,7.286h390.655v132.615 C497.427,451.883,451.883,497.427,395.901,497.427z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPol);
export default __webpack_public_path__ + "static/media/pol.833cff22444a0badcbcf8b98f81e5379.svg";
export { ForwardRef as ReactComponent };